import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { applicationParameters } from '../../../utilities/application-parameters';
import { AppState } from '../../../stores/redux-store';
import { SelectedProviderContext } from './SelectedProviderContext';

export const useSelectedProvider = () => {
  const provider = useContext(SelectedProviderContext);

  if (!provider) {
    throw new Error('Missing <SelectedProvider.Provider>');
  }

  return provider;
};

export const useSelectedProviderName = () => {
  // The provider can be pre-selected in the route
  const { providerName: routeParam } = useParams<{ providerName: string }>();
  // or in the query params.
  const appParam = applicationParameters.get('providerName');

  // When handling redirects we're getting a credentials entity that contains the provider.
  const credentialsProviderName = useSelector(
    (state: AppState) => state.credentials.data?.providerName
  );

  return routeParam || appParam || credentialsProviderName;
};
